// Защита сохранений для axios и для экземпляра из api/http.js.
//
// dedupeWrites: человек нажал «Сохранить» дважды, пока первый запрос ещё идёт
// (медленный ответ, моргнула связь). Второй такой же запрос на сервер не уходит,
// оба нажатия получают ответ первого — запись не задваивается.
//
// blockWrites: пока открыто окно техработ (MaintenanceWatcher), сохранения не
// отправляются вовсе: человек видит понятную ошибку, а набранное остаётся на странице.
import axios from "axios";

const WRITE_METHODS = ["post", "put", "patch", "delete"];

export const isWrite = (method) => WRITE_METHODS.includes(String(method || "get").toLowerCase());

// Ключ одинаковой записи. Считается в адаптере, после transformRequest: тело уже
// строка JSON. Файлы (FormData, Blob) не склеиваем — их не сравнить дёшево.
export function writeKey(config) {
  if (!isWrite(config.method)) return null;
  const { data } = config;
  if (data != null && typeof data !== "string") return null;
  return [
    String(config.method).toLowerCase(),
    config.baseURL || "",
    config.url || "",
    JSON.stringify(config.params ?? null),
    data ?? "",
  ].join(" ");
}

export function dedupeWrites(instance) {
  const inFlight = new Map();

  instance.interceptors.request.use((config) => {
    if (!isWrite(config.method)) return config;

    const send = axios.getAdapter(config.adapter);
    config.adapter = (cfg) => {
      const key = writeKey(cfg);
      if (!key) return send(cfg);

      const running = inFlight.get(key);
      if (running) return running;

      const request = Promise.resolve()
        .then(() => send(cfg))
        .finally(() => inFlight.delete(key));
      inFlight.set(key, request);
      return request;
    };
    return config;
  });

  return instance;
}

export function blockWrites(instances, makeError) {
  const registered = instances.map((instance) => [
    instance,
    instance.interceptors.request.use((config) =>
      isWrite(config.method) ? Promise.reject(makeError()) : config
    ),
  ]);

  return () => registered.forEach(([instance, id]) => instance.interceptors.request.eject(id));
}
